module.exports = "/assets/dist/images/CRSV_Certified_Dealer_Logo.png?30408e8d6ff10000021ef73a0e9cd295";